import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FileCSV from 'src/components/FileCSV';
import { Button, Typography } from '@components';
import { actions as modalActions } from '@store/ducks/modal';
import { actions as userActions } from '@store/ducks/user';
import ArrowRight from '@icons/arrow-right.svg';

import {
  ButtonWrapper,
  CounterRow,
  ErrorList,
  FileInputArea,
  ResultWrapper,
  TitleModal,
  Wrapper,
} from './styles';

const DeactivateBatch = () => {
  const dispatch = useDispatch();
  const { loading, batchResult, error } = useSelector((state) => state.user);
  const [file, setFile] = useState();

  const closeModal = useCallback(() => {
    dispatch(modalActions.close());
  }, [dispatch]);

  const handleFileChange = (selectedFile) => {
    setFile(selectedFile);
  };

  const handleProcess = () => {
    if (!file) return;
    const data = new FormData();
    data.append('file', file);
    dispatch(userActions.deactivateBatchRequest({ data }));
  };

  if (batchResult) {
    const { summary, errors } = batchResult;
    return (
      <>
        <TitleModal>
          <Typography as="h1" weight="bold" size="32px">
            Resultado da Inativação
          </Typography>
        </TitleModal>
        <Wrapper>
          <ResultWrapper>
            <CounterRow>✅ Inativados: {summary.deactivated}</CounterRow>
            <CounterRow>❌ Erros: {summary.errors}</CounterRow>
            <CounterRow>⏭ Ignorados: {summary.skipped}</CounterRow>

            {errors && errors.length > 0 && (
              <>
                <p style={{ marginTop: 16, marginBottom: 4, fontWeight: 600 }}>
                  Erros:
                </p>
                <ErrorList>
                  {errors.map((e) => (
                    <li key={e.email}>
                      {e.email} — {e.reason}
                    </li>
                  ))}
                </ErrorList>
              </>
            )}
          </ResultWrapper>

          <ButtonWrapper>
            <Button type="button" variant="primary" onClick={closeModal}>
              Fechar
            </Button>
          </ButtonWrapper>
        </Wrapper>
      </>
    );
  }

  return (
    <>
      <TitleModal>
        <Typography as="h1" weight="bold" size="32px">
          Inativar por Planilha
        </Typography>
      </TitleModal>
      <Wrapper>
        <p>
          Faça upload da planilha de colaboradores. Usuários com status
          &quot;Demitido&quot; terão o acesso ao Wise Up Online inativado
          automaticamente.
        </p>
        <p>Formatos aceitos: .csv</p>

        {error && (
          <p style={{ color: '#d32f2f' }}>
            Erro ao processar a planilha. Tente novamente.
          </p>
        )}

        <FileCSV onChange={handleFileChange}>
          <FileInputArea>
            <p>Selecione ou arraste aqui a planilha de demitidos.</p>
          </FileInputArea>
        </FileCSV>

        <ButtonWrapper>
          <Button
            type="button"
            variant="secondary"
            onClick={closeModal}
            className="secondary"
          >
            Cancelar
          </Button>
          <Button
            type="button"
            variant="primary"
            rightIcon={<ArrowRight />}
            onClick={handleProcess}
            disabled={!file || loading}
            loading={loading}
          >
            Processar
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </>
  );
};

export default DeactivateBatch;
